import React, { useContext, useState, useEffect, useCallback } from 'react';
import "../../Styles/PackDetails.css";
import { useNavigate } from 'react-router-dom';
import { Packs } from '../Context/PacksContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpLong, faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from "react-router-dom";
import packslist from "../../../JSONS/updatedPacks.json"
import examslist from "../../../JSONS/updatedExams.json"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import MakeItEasy from "./MakeItEasy"
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';

function PackDetailsRoute() {

  const Navigate = useNavigate();
  
  const [searchParams] = useSearchParams();
  const [VisualizePack,SetVisualizePack] = useState(searchParams.get("pack"))

  const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
  const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
  const GenderNum = decodedToken ? parseInt(decodedToken.gender) : null;
  const GenderCat = GenderNum === 1 ? "M" : "F"

  const MySwal = withReactContent(Swal)

  useEffect(() => {
    if(!searchParams.get("pack") || !packslist[VisualizePack]) {
      Navigate("/packs-de-examenes")
    }
  })

  window.onscroll = function() {
    if(document.URL.includes("detalles-de-pack") && document.getElementById("ToTheTop")) {
      let tmp = document.getElementById("ToTheTop")
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        tmp.className = tmp.className.replace(" ScrollBackToTopHidden", "");
      } else {
        if(!tmp.className.includes("ScrollBackToTopHidden")) tmp.className += " ScrollBackToTopHidden"
      }
    }
  }
  
  const {
    BasketPacks, SetBasketPacks, ExamsPerProduct, SetExamsPerProduct, SetAdded, SetPurchased
  } = useContext(Packs);

  const others = ["Imagenología", "Procedimientos"]

  const [Gender, setGender] = useState(VisualizePack === null || VisualizePack.length === 2 ? null : packslist[VisualizePack] && (packslist[VisualizePack].gender === "Mixed" || packslist[VisualizePack].gender.length === 0) && !packslist[VisualizePack].depends ? 'None' : GenderCat);
  const [ChosenExams, setChosenExams] = useState([]);
  const [OneTime, setOneTime] = useState(true);
  const [ProPrice, setProPrice] = useState(VisualizePack === null || VisualizePack.length === 2 ? null : packslist[VisualizePack] ? packslist[VisualizePack].price : null);
  const [Page,setPage] = useState(1)
  const [ExamsShown,setExamsShown] = useState(window.innerWidth <= 420 ? 1 : window.innerWidth <= 720 ? 2 : 4)
  const [PackPage,setPackPage] = useState(1)
  const [PacksShown,setPacksShown] = useState(window.innerWidth <= 620 ? 1 : window.innerWidth <= 920 ? 2 : 3)

  function ChangePack(newPack) {
    setChosenExams([])
    setProPrice(packslist[newPack].price)
    setGender((packslist[newPack].gender === "Mixed" | packslist[VisualizePack].gender.length === 0) & !packslist[newPack].depends ? 'None' : packslist[newPack].gender === "M" ? 'M' : 'F')
    SetVisualizePack(newPack)
    setOneTime(true)
  };

  const PreSelect = useCallback((gender = Gender) => {
    if(packslist[VisualizePack] && gender === "None") {
      let Selected = packslist[VisualizePack].exams.filter((a,ind) => packslist[VisualizePack].selected[ind])
      let loadedExams = packslist[VisualizePack].exams.filter(a => examslist[a].emission !== "")
      if(VisualizePack === "PCM00YMC008") {
        for(let i=0;i<loadedExams.length;i++) {
          if(Selected.includes(loadedExams[i]) && loadedExams[i] !== "YMC008" && loadedExams[i] !== "YMC009" && loadedExams[i] !== "YMC043") {
            let tmp = document.getElementById(loadedExams[i])
            if(tmp) tmp.checked = true
          }
        }
        let tmp = document.getElementById("PCM00YMC008")
        if(tmp) tmp.checked = true
      } else {
        for(let i=0;i<loadedExams.length;i++) {
          if(Selected.includes(loadedExams[i])) {
            let tmp = document.getElementById(loadedExams[i])
            if(tmp) tmp.checked = true
          }
        }
      }
      setChosenExams(Selected.filter(a => loadedExams.includes(a)))
      //console.log(loadedExams)
    } else if(packslist[VisualizePack]) {
      let Selected = packslist[VisualizePack][gender].exams.filter((a,ind) => packslist[VisualizePack][gender].selected[ind])
      let loadedExams = packslist[VisualizePack][gender].exams.filter(a => examslist[a].emission !== "")
      for(let i=0;i<loadedExams.length;i++) {
        if(Selected.includes(loadedExams[i])) {
          let tmp = document.getElementById(loadedExams[i])
          if(tmp) tmp.checked = true
        }
      }
      setChosenExams(Selected.filter(a => loadedExams.includes(a)))
      //console.log(Selected)
    }
    //let checked={Selected.includes(key) ? true : false}
  }, [Gender, VisualizePack])

  useEffect(() => {
    if(OneTime && document.getElementById("ManageAll")) {
      PreSelect()
      setOneTime(false)
      Navigate("/packs-de-examenes/detalles-de-pack?pack=".concat(VisualizePack))
    }
  }, [OneTime, PreSelect, Navigate, VisualizePack])

  function handleChosen(id) {
    let tmp = document.getElementById(id)
    let listtmp = ChosenExams
    let fullprice = ProPrice
    if(id === 'ChooseAll') {
      if (tmp.checked) {
        fullprice = packslist[VisualizePack].price
        if(Gender === "None") {
          for(let i=0; i<packslist[VisualizePack].exams.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack].exams[i])
            if(tmp2) {
              tmp2.checked = true
              listtmp.push(packslist[VisualizePack].exams[i])
            }
          }
          for(let i=0; i<packslist[VisualizePack].examsPro.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack].examsPro[i])
            if(tmp2) {
              tmp2.checked = true
              fullprice += packslist[VisualizePack].pricesPro[i]
              listtmp.push(packslist[VisualizePack].examsPro[i])
            } 
          }
          if(VisualizePack === "PDM00YMC005") {
            let tmp2 = document.getElementById("PDM00YMC005")
            tmp2.checked = true
            let group = ["YMC036","YMC037"]
            listtmp.push("YMC036","YMC037")
            let indexPro = packslist[VisualizePack].examsPro.indexOf(group[0]);
            fullprice += packslist[VisualizePack].pricesPro[indexPro]
          }
          if(VisualizePack === "PCM00YMC008") {
            let tmp2 = document.getElementById("PCM00YMC008")
            tmp2.checked = true
            listtmp.push("YMC008","YMC009","YMC043")
          }
        } else {
          for(let i=0; i<packslist[VisualizePack][Gender].exams.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack][Gender].exams[i])
            if(tmp2) {
              tmp2.checked = true
              listtmp.push(packslist[VisualizePack][Gender].exams[i])
            }
          }
          for(let i=0; i<packslist[VisualizePack][Gender].examsPro.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack][Gender].examsPro[i])
            if(tmp2) {
              tmp2.checked = true
              fullprice += packslist[VisualizePack][Gender].pricesPro[i]
              listtmp.push(packslist[VisualizePack][Gender].examsPro[i])
            } 
          }
        }
      } else {
        fullprice = packslist[VisualizePack].price
        if(Gender === "None") {
          listtmp = []
          for(let i=0; i<packslist[VisualizePack].exams.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack].exams[i])
            if(tmp2) tmp2.checked = false
          }
          for(let i=0; i<packslist[VisualizePack].examsPro.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack].examsPro[i])
            if(tmp2) {
              tmp2.checked = false
            }
          }
          if(VisualizePack === "PDM00YMC005") {
            let tmp2 = document.getElementById("PDM00YMC005")
            tmp2.checked = false
          }
          if(VisualizePack === "PCM00YMC008") {
            let tmp2 = document.getElementById("PCM00YMC008")
            tmp2.checked = false
          }
        } else {
          listtmp = []
          for(let i=0; i<packslist[VisualizePack][Gender].exams.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack][Gender].exams[i])
            if(tmp2) tmp2.checked = false
          }
          for(let i=0; i<packslist[VisualizePack][Gender].examsPro.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack][Gender].examsPro[i])
            if(tmp2) {
              tmp2.checked = false
            } 
          }
        }
      }
    }
    else if(id === "PDM00YMC005") {
      let group = ["YMC036","YMC037"]
      if (tmp.checked) {
        for(let i=0;i<group.length;i++) {
          listtmp.push(group[i])
        }
        let indexPro = packslist[VisualizePack].examsPro.indexOf(group[0]);
        fullprice += packslist[VisualizePack].pricesPro[indexPro]
      } else {
        for(let i=0;i<group.length;i++) {
          let index = listtmp.indexOf(group[i]);
          if (index > -1) { 
            listtmp.splice(index, 1); 
          }
        }
        let indexPro = packslist[VisualizePack].examsPro.indexOf(group[0]);
        fullprice -= packslist[VisualizePack].pricesPro[indexPro]
      }
    } else if(id === "PCM00YMC008") {
      let group = ["YMC008","YMC009","YMC043"]
      if (tmp.checked) {
        for(let i=0;i<group.length;i++) {
          listtmp.push(group[i])
        }
      } else {
        for(let i=0;i<group.length;i++) {
          let index = listtmp.indexOf(group[i]);
          if (index > -1) { 
            listtmp.splice(index, 1); 
          }
        }
      }
    } else {
      if (tmp.checked) {
        listtmp.push(id)
        if(Gender === "None") { 
          if(packslist[VisualizePack].examsPro.includes(id)) {
            let indexPro = packslist[VisualizePack].examsPro.indexOf(id);
            fullprice += packslist[VisualizePack].pricesPro[indexPro]
          }
        }
        if(Gender !== "None"){ 
          if(packslist[VisualizePack][Gender].examsPro.includes(id)) {
            let indexPro = packslist[VisualizePack][Gender].examsPro.indexOf(id);
            fullprice += packslist[VisualizePack][Gender].pricesPro[indexPro]
          }
        }
      } else {
        let index = listtmp.indexOf(id);
        if (index > -1) { 
          listtmp.splice(index, 1); 
        }
        if(Gender === "None") { 
          if(packslist[VisualizePack].examsPro.includes(id)) {
            let indexPro = packslist[VisualizePack].examsPro.indexOf(id);
            fullprice -= packslist[VisualizePack].pricesPro[indexPro]
          }
        }
        if(Gender !== "None"){ 
          if(packslist[VisualizePack][Gender].examsPro.includes(id)) {
            let indexPro = packslist[VisualizePack][Gender].examsPro.indexOf(id);
            fullprice -= packslist[VisualizePack][Gender].pricesPro[indexPro]
          }
        }
      }
    }

    if(fullprice !== ProPrice) {
      changePriceSize()
    }

    setProPrice(fullprice)
    //console.log([...new Set(listtmp)])
    setChosenExams([...new Set(listtmp)])
  }

  function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  async function changePriceSize() {
    let tmpPrice = document.getElementById("PriceDiv")
    tmpPrice.className += " PriceChanged"
    await delay(1000);
    tmpPrice.className = tmpPrice.className.replace(" PriceChanged","")
  }

  function ModifyPackCheckout(pack) {
    let listOfPacks = BasketPacks
    let examsOfPacks = ExamsPerProduct
    if(BasketPacks.includes(pack)) {
        let index = listOfPacks.indexOf(pack);
        if (index > -1) { 
            listOfPacks.splice(index, 1); 
        }
        delete examsOfPacks[pack]
        MySwal.fire({
          position: "top-end",
          icon: "success",
          iconColor: "red",
          title: "Se ha eliminado el pack de su orden médica",
          showConfirmButton: false,
          timer: 1500
        });
    } else {
        listOfPacks.push(pack)
        let dict = {
          "exams": ChosenExams,
          "price": ProPrice
        }
        examsOfPacks[pack] = {...dict}
    } 
    localStorage.setItem("BasketPacks", JSON.stringify([...listOfPacks]))
    SetBasketPacks([...listOfPacks])
    SetExamsPerProduct({...examsOfPacks})
    SetAdded(false)
    SetPurchased(false)
  }

  function toggleAdditional(id) {
    let tmp = document.getElementById(id)
    if(tmp.className.includes("InformationCollapsed")) {
      tmp.className = tmp.className.replace(" InformationCollapsed", "");
    } else {
      tmp.className += " InformationCollapsed"
    }
  }

  function toggleDescription(id,type) {
    let tmp = document.getElementById(id.concat("More"))
    let tmp2 = document.getElementById(id.concat("Less"))
    if(type === "More") {
        tmp.className += " PacksSelectPackBoxWhiteBoxDescriptionHidden"
        tmp2.className = tmp2.className.replace(" PacksSelectPackBoxWhiteBoxDescriptionHidden", "");
    } else {
        tmp.className = tmp.className.replace(" PacksSelectPackBoxWhiteBoxDescriptionHidden", "");
        tmp2.className += " PacksSelectPackBoxWhiteBoxDescriptionHidden"
    }
  }

  function changeExamPage(num) {
    setPage(num+Page)
    let tmp = document.getElementsByClassName("PackDetailsInnerBoxLowerLinesIndividualPageDot")
    for(let i=0;i<tmp.length;i++) {
      if(tmp[i].className.includes("PackDetailsActiveDot")) {
        tmp[i].className = tmp[i].className.replace(" PackDetailsActiveDot", "");
      }
    }
    let tmp2 = document.getElementById('pageDot'.concat(num+Page))
    tmp2.className += " PackDetailsActiveDot"
  }

  const ChangeNumberOfExams = useCallback(() => {
    let current = ExamsShown
    let current2 = PacksShown
    let different = false
    let different2 = false

    if(window.innerWidth <= 420) {
      setExamsShown(1)
      if(current !== 1) different = true
    } else if(window.innerWidth <= 720) {
      setExamsShown(2)
      if(current !== 2) different = true
    } else {
      setExamsShown(4)
      if(current !== 4) different = true
    }

    if(window.innerWidth <= 620) {
      setPacksShown(1)
      if(current2 !== 1) different2 = true
    } else if(window.innerWidth <= 920) {
      setPacksShown(2)
      if(current2 !== 2) different2 = true
    } else {
      setPacksShown(3)
      if(current2 !== 3) different2 = true
    }

    if(different) {
      setPage(1)
      let tmp = document.getElementsByClassName("PackDetailsInnerBoxLowerLinesIndividualPageDot")
      for(let i=0;i<tmp.length;i++) {
        if(tmp[i].className.includes("PackDetailsActiveDot")) {
          tmp[i].className = tmp[i].className.replace(" PackDetailsActiveDot", "");
        }
      }
      let tmp2 = document.getElementById('pageDot'.concat(1))
      if (tmp2) tmp2.className += " PackDetailsActiveDot"
    }

    if(different2) {
      setPackPage(1)
    }
  }, [ExamsShown, PacksShown])

  useEffect(() => {
    window.addEventListener("resize", ChangeNumberOfExams);
    return () => window.removeEventListener("resize", ChangeNumberOfExams);
  }, [ChangeNumberOfExams]);
  
    return (
      <>
      {VisualizePack === null || VisualizePack.length === 2 ?
      null :
      <div className="PacksSelectOuterDiv">
        <div className="UserProfileInnerDiv">
            <div className='UserProfileWhiteBox PacksSelectWhiteBlock' id="ManageAll" style={{color:"#330066", marginBlockEnd:"20px"}}>
     <div className="PackDetailsAll">
      <div className="PackDetailsLeftSide">
        <div className="PackDetailsLeftSideUpperBlock">
        <div className="PackDetailsPackBoxImage" style={{backgroundImage: !VisualizePack.includes("043") ? "url('https://static.yomecontrolo.cl/public/img/packs/"+ VisualizePack +".png')" : "url('https://static.yomecontrolo.cl/public/img/packs/CM00YMC001.png')",backgroundPosition: 'center',backgroundPositionY: 'top',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}><div className="PackDetailsPackBoxImageGradient"></div></div>
        <div className="PackDetailsPackTextContainter">
          <h2 className="PackDetailsPackTitle">{packslist[VisualizePack] ? packslist[VisualizePack].name : null}</h2>
          <div className="PackDetailsPackDescription">{packslist[VisualizePack] ? packslist[VisualizePack].description : null}</div>
          {(Gender !== "None" && packslist[VisualizePack] && packslist[VisualizePack][Gender].examsPro.length === 0) || (Gender === "None" && packslist[VisualizePack].examsPro.length === 0) ? null :
          <>
          <div className="PackDetailsPackProWarning">IMPORTANTE: Agregar exámenes ECR a la orden médica incurre costos adicionales.</div>
          <div className="PackDetailsPackProWarning" style={{fontWeight:"600"}}>ECR: Exámenes Complementarios Recomendados</div>
          </>
          }
          <div className='PackDetailsPackPriceFlex'>
            {ProPrice === 0 ?
            <div className='PackDetailsPackPriceFree' id="PriceDiv">Gratis</div>
            :
            <div className='PackDetailsPackPrice' id="PriceDiv">${ProPrice}</div>
}
            {BasketPacks.includes(VisualizePack) ?
            <div className='GeneralPurpleButtonFlex PackDetailsPackAddToOrderButton'  
              onClick={() => { 
                MySwal.fire({
                  position: "center",
                  html: 
                  <div className="FullAlertWidth2" style={{maxWidth:"590px", paddingInline:"3vw"}}>
                      <h3 className="FullAlertTitle">Eliminaras este pack de exámenes de tu orden médica</h3>
                      <div className="FullAlertSubtitle" style={{color:"#6633FF"}}>¿Estas seguro?</div>
                      <div className='FullAlertButtonFlex'>
                        <div className="GeneralWhiteButtonFlex UserWelcomeBlockPageButton FullAlertButton" style={{maxWidth:"190px"}} onClick={() => {MySwal.close();}}>
                            <div className="GeneralButtonText">Cancelar</div>
                        </div>
                        <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton FullAlertButton" style={{maxWidth:"190px"}} onClick={() => {ModifyPackCheckout(VisualizePack);}}>
                            <div className="GeneralButtonText">Confirmar</div>
                        </div>
                      </div>
                  </div>,
                  color: "#340066",
                  customClass: 'swal-wide',
                  showConfirmButton: false,
                  width: "fit-content",
                  allowOutsideClick: false
              })}}>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/WhiteExamIcon.svg" />
              <div className='PackDetailsChoiceLabel'>Eliminar de Orden Médica</div>
            </div>
            : ChosenExams.length === 0 ? 
            <div className='GeneralPurpleButtonFlex PackDetailsPackAddToOrderButtonDisabled'>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/WhiteExamIcon.svg" />
              <div className='PackDetailsChoiceLabel'>Añadir a Orden Médica</div>
            </div>
            :
            <div className='GeneralPurpleButtonFlex PackDetailsPackAddToOrderButton' 
                onClick={() => {ModifyPackCheckout(VisualizePack); 
              //    MySwal.fire({
              //  title: "Se ha añadido el pack a su orden médica",
              //  confirmButtonText: "Genera tu órden médica"
              //}).then((result) => {
              //  /* Read more about isConfirmed, isDenied below */
              //  if (result.isConfirmed) {
              //    Navigate("/orden-medica");
              //  }
              //});
              MySwal.fire({
                position: "center",
                html: 
                <div className="FullAlertWidth2" style={{maxWidth:"590px", paddingInline:"3vw"}}>
                    <img alt="" className='FullAlertIcon' src="https://static.yomecontrolo.cl/public/icons/SkyBlueAddToOrderIcon.svg" />
                    <h3 className="FullAlertTitle">Pack agregado a la orden médica exitosamente</h3>
                    <div className="FullAlertSubtitle" style={{color:"#6633FF"}}>Puedes seguir agregando otros o ir a ver tu orden</div>
                    <div className='FullAlertButtonFlex'>
                      <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton FullAlertButton" style={{maxWidth:"190px"}} onClick={() => {MySwal.close(); Navigate("/orden-medica");}}>
                        Ver Orden<div className='triangle'><i className='innerarrowWhite'></i></div>
                      </div>
                    </div>
                </div>,
                color: "#340066",
                customClass: 'swal-wide',
                showConfirmButton: false,
                width: "fit-content",
            })}}>
                <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/WhiteExamIcon.svg" />
                <div className='PackDetailsChoiceLabel'>Añadir a Orden Médica</div>
              </div>
}
          </div>
        </div>
        </div>
      </div>
      <div className="PackDetailsRightSide">
        <div className="PackDetailsChoiceContainer">
          <div className="PackDetailsChoiceTitleFlex">
            <img className="PackDetailsChoiceIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/DarkPurpleExamIcon.svg" />
            <h4 className="PackDetailsChoiceTitle">Detalle de Exámenes</h4>
          </div>
          <div className="PackDetailsChoiceDescription">
            Un chequeo preventivo te permitirá conocer tu estado de salud para evitar aparición de enfermedades y abordaje temprano de posibles enfermedades.
            Escoge aquí los exámenes del pack que te interesan.
          </div>
          <div className="PackDetailsChoiceChooseAllDiv">
            <input type="checkbox" name="selectExam" className="PackDetailsChoiceChooseAllInput" id={'ChooseAll'} onClick={() => handleChosen('ChooseAll')}/>
            <span className="PackDetailsChoiceChooseAllText">Elegir todos</span>
          </div>
          {packslist[VisualizePack] && packslist[VisualizePack].depends ?
          <>
          {packslist[VisualizePack][Gender].exams.map(a => examslist[a].emission).includes('Laboratorio') | packslist[VisualizePack][Gender].examsPro.map(a => examslist[a].emission).includes('Laboratorio') ?
          <>
            <div className="PackDetailsChoiceLabelFlex">
              <h5 className="PackDetailsChoiceLabel">Laboratorio</h5>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/PurpleExamLaboratoryIcon.svg" />
            </div>
            <div className="PackDetailsChoiceExams">
            {packslist[VisualizePack][Gender].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Laboratorio" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={key} onClick={() => handleChosen(key)}/>
                <span className="PackDetailsChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack][Gender].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack][Gender].examsPro[key]].emission === "Laboratorio" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={packslist[VisualizePack][Gender].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack][Gender].examsPro[key])}/>
                <span className="PackDetailsChoiceExamName"><span className="PackDetailsChoiceExamPRO">ECR</span> {examslist[packslist[VisualizePack][Gender].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack][Gender].examsPro[key]].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="PackDetailsChoiceExamPrice">(+${packslist[VisualizePack][Gender].pricesPro[key]})</div>
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack][Gender].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div> 
          </>
          : null}
          {packslist[VisualizePack] && others.some((el) => packslist[VisualizePack][Gender].exams.map(a => examslist[a].emission).includes(el)) | others.some((el) => packslist[VisualizePack][Gender].examsPro.map(a => examslist[a].emission).includes(el)) ?
          <>
            <div className="PackDetailsChoiceLabelFlex">
              <h5 className="PackDetailsChoiceLabel">Imagenología y Procedimientos</h5>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/PurpleExamImagenologyIcon.svg" />
            </div>
            <div className="PackDetailsChoiceExams">
            {packslist[VisualizePack][Gender].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Imagenología" | examslist[key].emission === "Procedimientos" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="PackDetailsChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack][Gender].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack][Gender].examsPro[key]].emission === "Imagenología" | examslist[packslist[VisualizePack][Gender].examsPro[key]].emission === "Procedimientos" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={packslist[VisualizePack][Gender].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack][Gender].examsPro[key])}/>
                <span className="PackDetailsChoiceExamName"><span className="PackDetailsChoiceExamPRO">ECR</span> {examslist[packslist[VisualizePack][Gender].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack][Gender].examsPro[key]].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="PackDetailsChoiceExamPrice">(+${packslist[VisualizePack][Gender].pricesPro[key]})</div>
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack][Gender].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          {packslist[VisualizePack] && packslist[VisualizePack][Gender].exams.map(a => examslist[a].emission).includes('Derivaciones') | packslist[VisualizePack][Gender].examsPro.map(a => examslist[a].emission).includes('Derivaciones') ?
          <>
            <div className="PackDetailsChoiceLabelFlex">
              <h5 className="PackDetailsChoiceLabel">Derivaciones</h5>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/PurpleExamDerivationsIcon.svg" />
            </div>
            <div className="PackDetailsChoiceExams">
            {packslist[VisualizePack][Gender].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Derivaciones" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="PackDetailsChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack][Gender].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack][Gender].examsPro[key]].emission === "Derivaciones" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={packslist[VisualizePack][Gender].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack][Gender].examsPro[key])}/>
                <span className="PackDetailsChoiceExamName"><span className="PackDetailsChoiceExamPRO">ECR</span> {examslist[packslist[VisualizePack][Gender].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack][Gender].examsPro[key]].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="PackDetailsChoiceExamPrice">(+${packslist[VisualizePack][Gender].pricesPro[key]})</div>
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack][Gender].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          {/*packslist[VisualizePack][Gender].exams.map(a => examslist[a].emission).includes("") ?
          <>
            <div className="PackDetailsChoiceLabel">
              Otros
            </div>
            <div className="PackDetailsChoiceExams">
            {packslist[VisualizePack][Gender].exams.filter(a => examslist[a].emission === "").map((key) => (
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="PackDetailsChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                <div className="PackDetailsChoiceExamInfo">?
                  <span className="PackDetailsChoiceTooltip">{examslist[key].additional}</span>
                </div>
                }
              </div>
              </>
            ))}
            </div>
          </>
          : null
*/}
          </>
          
        : 
          <>
          {packslist[VisualizePack] && packslist[VisualizePack].exams.map(a => examslist[a].emission).includes('Laboratorio') | packslist[VisualizePack].examsPro.map(a => examslist[a].emission).includes('Laboratorio') ?
          <>
            <div className="PackDetailsChoiceLabelFlex">
              <h5 className="PackDetailsChoiceLabel">Laboratorio</h5>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/PurpleExamLaboratoryIcon.svg" />
            </div>
            <div className="PackDetailsChoiceExams">
            {VisualizePack === "PCM00YMC008" ?
            <>
            {packslist[VisualizePack].exams.filter(a => !["YMC008","YMC009","YMC043"].includes(a)).map((key) => (
              <div key={key}>
              {examslist[key].emission === "Laboratorio" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={key} onClick={() => handleChosen(key)}/>
                <span className="PackDetailsChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={"PCM00YMC008"} onClick={() => handleChosen("PCM00YMC008")}/>
                <span className="PackDetailsChoiceExamGroupName">&nbsp;Pruebas Tiroideas</span>
              </div>
              {packslist[VisualizePack].exams.filter(a => ["YMC008","YMC009","YMC043"].includes(a)).map((key) => (
                <div key={key}>
                <div className="PackDetailsChoiceExamsFlexed">
                  <span className="PackDetailsChoiceExamName">&emsp; {examslist[key].name}</span>
                  {examslist[key].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </div>
              ))}
            </>
            :
            <>
            {packslist[VisualizePack].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Laboratorio" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={key} onClick={() => handleChosen(key)}/>
                <span className="PackDetailsChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </>}
            {VisualizePack === "PDM00YMC005" ?
            <>
             <div className="PackDetailsChoiceExamsFlexed">
                  <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={packslist[VisualizePack].examsPro[2]} onClick={() => handleChosen(packslist[VisualizePack].examsPro[2])}/>
                  <span className="PackDetailsChoiceExamName"><span className="PackDetailsChoiceExamPRO">ECR</span> {examslist[packslist[VisualizePack].examsPro[2]].name}</span>
                  {examslist[packslist[VisualizePack].examsPro[2]].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(2))}>?</div>
                }
                <div className="PackDetailsChoiceExamPrice">(+${packslist[VisualizePack].pricesPro[2]})</div>
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(2)}>{examslist[packslist[VisualizePack].examsPro[2]].additional}</div>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={"PDM00YMC005"} onClick={() => handleChosen("PDM00YMC005")}/>
                <span className="PackDetailsChoiceExamGroupName"><span className="PackDetailsChoiceExamPRO">ECR</span>&nbsp;Panel ETS por PCR en orina</span>
                <div className="PackDetailsChoiceExamPrice">(+${packslist[VisualizePack].pricesPro[0]})</div>
              </div>
              {[...Array(packslist[VisualizePack].examsPro.length-1).keys()].map((key) => (
                <div key={key}>
                <div className="PackDetailsChoiceExamsFlexed">
                  <span className="PackDetailsChoiceExamName">&emsp;<span className="PackDetailsChoiceExamPRO">ECR</span> {examslist[packslist[VisualizePack].examsPro[key]].name}</span>
                  {examslist[packslist[VisualizePack].examsPro[key]].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack].examsPro[key]].additional}</div>
              </div>
              ))}
            </>
            :
            <>
            {packslist[VisualizePack].examsPro.length !== 0 ?
            <>
              {[...Array(packslist[VisualizePack].examsPro.length).keys()].map((key) => (
                <div key={key}>
                {examslist[packslist[VisualizePack].examsPro[key]].emission === "Laboratorio" ?
                <>
                <div className="PackDetailsChoiceExamsFlexed">
                  <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={packslist[VisualizePack].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack].examsPro[key])}/>
                  <span className="PackDetailsChoiceExamName"><span className="PackDetailsChoiceExamPRO">ECR</span> {examslist[packslist[VisualizePack].examsPro[key]].name}</span>
                  {examslist[packslist[VisualizePack].examsPro[key]].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="PackDetailsChoiceExamPrice">(+${packslist[VisualizePack].pricesPro[key]})</div>
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack].examsPro[key]].additional}</div>
              </>
                :
                null}
                </div>
              ))}
              </>: null}
              </>}
            </div> 
          </>
          : null}
          {packslist[VisualizePack] && others.some((el) => packslist[VisualizePack].exams.map(a => examslist[a].emission).includes(el)) | others.some((el) => packslist[VisualizePack].examsPro.map(a => examslist[a].emission).includes(el)) ?
          <>
            <div className="PackDetailsChoiceLabelFlex">
              <h5 className="PackDetailsChoiceLabel">Imagenología y Procedimientos</h5>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/PurpleExamImagenologyIcon.svg" />
            </div>
            <div className="PackDetailsChoiceExams">
            {packslist[VisualizePack].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Imagenología" | examslist[key].emission === "Procedimientos" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="PackDetailsChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack].examsPro[key]].emission === "Imagenología" | examslist[packslist[VisualizePack].examsPro[key]].emission === "Procedimientos" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={packslist[VisualizePack].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack].examsPro[key])} />
                <span className="PackDetailsChoiceExamName"><span className="PackDetailsChoiceExamPRO">ECR</span> {examslist[packslist[VisualizePack].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack].examsPro[key]].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="PackDetailsChoiceExamPrice">(+${packslist[VisualizePack].pricesPro[key]})</div>
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          {packslist[VisualizePack] && packslist[VisualizePack].exams.map(a => examslist[a].emission).includes('Derivaciones') | packslist[VisualizePack].examsPro.map(a => examslist[a].emission).includes('Derivaciones') ?
          <>
            <div className="PackDetailsChoiceLabelFlex">
              <h5 className="PackDetailsChoiceLabel">Derivaciones</h5>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/PurpleExamDerivationsIcon.svg" />
            </div>
            <div className="PackDetailsChoiceExams">
            {packslist[VisualizePack].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Derivaciones" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="PackDetailsChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack].examsPro[key]].emission === "Derivaciones" ?
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={packslist[VisualizePack].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack].examsPro[key])} />
                <span className="PackDetailsChoiceExamName"><span className="PackDetailsChoiceExamPRO">ECR</span> {examslist[packslist[VisualizePack].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack].examsPro[key]].additional === "" ?
                null :
                  <div className="PackDetailsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="PackDetailsChoiceExamPrice">(+${packslist[VisualizePack].pricesPro[key]})</div>
              </div>
              <div className="PackDetailsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          {/*packslist[VisualizePack].exams.map(a => examslist[a].emission).includes("") ?
          <>
            <div className="PackDetailsChoiceLabel">
              Otros
            </div>
            <div className="PackDetailsChoiceExams">
            {packslist[VisualizePack].exams.filter(a => examslist[a].emission === "").map((key) => (
              <>
              <div className="PackDetailsChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="PackDetailsChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="PackDetailsChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                <div className="PackDetailsChoiceExamInfo">?
                  <span className="PackDetailsChoiceTooltip">{examslist[key].additional}</span>
                </div>
                }
              </div>
              </>
            ))}
            </div>
          </>
          : null */}
          </> }
        </div>
      </div>
     </div>

     {packslist[VisualizePack] && packslist[VisualizePack].depends ?
     <div className='PackDetailsAllExamsDivContainer'>
     <div className='PackDetailsAllExamsDiv'>
        <div className="PackDetailsAllExamsPageMainTitleFlex">
          <img className="PackDetailsAllExamsPageIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueMedicalDataIcon.svg" />
          <h5 className="PackDetailsAllExamsPageMainTitle">Exámenes:</h5>
          <h5 className="PackDetailsAllExamsPageMainTitle">({[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length})</h5>
        </div>
       <div className="PackDetailsAllExamsHorizontalLine"></div>
         <div className="PackDetailsAllExamsFlexFullLine">
           {Page === 1 ?
           null :
           <div className='PackDetailsAllExamsLeftArrowDiv' onClick={() => changeExamPage(-1)}>
             <FontAwesomeIcon 
               icon={faArrowRightLong} 
               className='PackDetailsAllExamsLeftArrow text-end fa-rotate-180'
             />
           </div>
           }
           <div className="PackDetailsAllExamsFlexExamLine">
             {[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].slice(ExamsShown*(Page-1),ExamsShown*Page).map((exam) => (
             <div className="PackDetailsAllExamsSingleExamBlock" key={exam}>
               <div className="PackDetailsAllExamsSingleExamBlockUpLine">
                 <div className="PackDetailsAllExamsSingleExamBlockName">{examslist[exam].name}</div>
               </div>
               <div className="PackDetailsAllExamsSingleExamBlockDescr">{examslist[exam].description}</div>
             </div>
             ))}
           </div>
           {Page === Math.ceil([...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length / ExamsShown) ?
           null :
           <div className='PackDetailsAllExamsRightArrowDiv' onClick={() => changeExamPage(1)}>
             <FontAwesomeIcon 
               icon={faArrowRightLong} 
               className='PackDetailsAllExamsRightArrow text-end'
             />
           </div>
           }
         </div>
         <div className='PackDetailsAllExamsDotsDiv'>
           <div className="PackDetailsInnerBoxLowerLinesIndividualPageDot PackDetailsActiveDot" id="pageDot1"></div>
           {[...Array(Math.ceil([...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length / ExamsShown)-1).keys()].map((dots) => (
             <div className="PackDetailsInnerBoxLowerLinesIndividualPageDot" key={'pageDot'.concat(dots+2)} id={'pageDot'.concat(dots+2)}></div>
           ))}
         </div>
         {[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].length !== 0 ?
         <>
      <div className="PackDetailsAllExamsDerivations">
        <div className="PackDetailsAllExamsPageMainTitleFlex">
          <img className="PackDetailsAllExamsPageIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueMedicalDataIcon.svg" />
          <h5 className="PackDetailsAllExamsPageMainTitle">Derivaciones:</h5>
          <h5 className="PackDetailsAllExamsPageMainTitle">({[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].length})</h5>
        </div>
        <div className="PackDetailsAllExamsHorizontalLine"></div>
          <div className="PackDetailsAllExamsFlexFullLine">
            <div className="PackDetailsAllDerivationsFlexExamLine">
              {[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].map((exam) => (
              <div className="PackDetailsAllDerivationsSingleExamBlock" key={exam}>
                <div className="PackDetailsAllExamsSingleExamBlockUpLine">
                  <div className="PackDetailsAllExamsSingleExamBlockName">{examslist[exam].name}</div>
                </div>
                <div className="PackDetailsAllExamsSingleExamBlockDescr">{examslist[exam].description}</div>
              </div>
              ))}
            </div>
          </div>
        </div>
        </>
        : null}
     </div>
    </div>
     : packslist[VisualizePack] ?
     <div className='PackDetailsAllExamsDivContainer'>
      <div className='PackDetailsAllExamsDiv'>
        { packslist[VisualizePack] && [...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length === 0 ?
        null :
        <>
        <div className="PackDetailsAllExamsPageMainTitleFlex">
          <img className="PackDetailsAllExamsPageIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueMedicalDataIcon.svg" />
          <h5 className="PackDetailsAllExamsPageMainTitle">Exámenes:</h5>
          <h5 className="PackDetailsAllExamsPageMainTitle">({[...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length})</h5>
        </div>
        <div className="PackDetailsAllExamsPageMainSubtitle">Cada examen posee una función, descubre sobre ellos</div>
        <div className="PackDetailsAllExamsHorizontalLine"></div>
          <div className="PackDetailsAllExamsFlexFullLine">
            {Page === 1 ?
            null :
            <div className='PackDetailsAllExamsLeftArrowDiv' onClick={() => changeExamPage(-1)}>
              <FontAwesomeIcon 
                icon={faArrowRightLong} 
                className='PackDetailsAllExamsLeftArrow text-end fa-rotate-180'
              />
            </div>
            }
            <div className="PackDetailsAllExamsFlexExamLine">
              {packslist[VisualizePack] && [...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].slice(ExamsShown*(Page-1),ExamsShown*Page).map((exam) => (
              <div className="PackDetailsAllExamsSingleExamBlock" key={exam}>
                <div className="PackDetailsAllExamsSingleExamBlockUpLine">
                  <div className="PackDetailsAllExamsSingleExamBlockName">{examslist[exam].name}</div>
                </div>
                <div className="PackDetailsAllExamsSingleExamBlockDescr">{examslist[exam].description}</div>
              </div>
              ))}
            </div>
            {packslist[VisualizePack] && Page === Math.ceil([...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length / ExamsShown) ?
            null :
            <div className='PackDetailsAllExamsRightArrowDiv' onClick={() => changeExamPage(1)}>
              <FontAwesomeIcon 
                icon={faArrowRightLong} 
                className='PackDetailsAllExamsRightArrow text-end'
              />
            </div>
            }
          </div>
          <div className='PackDetailsAllExamsDotsDiv'>
            <div className="PackDetailsInnerBoxLowerLinesIndividualPageDot PackDetailsActiveDot" id="pageDot1"></div>
            {packslist[VisualizePack] && [...Array(Math.ceil([...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length / ExamsShown)-1).keys()].map((dots) => (
              <div className="PackDetailsInnerBoxLowerLinesIndividualPageDot" key={'pageDot'.concat(dots+2)} id={'pageDot'.concat(dots+2)}></div>
            ))}
          </div>
          </>}
          {packslist[VisualizePack] && [...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].length !== 0 ?
         <>
      <div className="PackDetailsAllExamsDerivations">
        <div className="PackDetailsAllExamsPageMainTitleFlex">
          <img className="PackDetailsAllExamsPageIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueMedicalDataIcon.svg" />
          <h5 className="PackDetailsAllExamsPageMainTitle">Derivaciones:</h5>
          <h5 className="PackDetailsAllExamsPageMainTitle">({[...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].length})</h5>
        </div>
        <div className="PackDetailsAllExamsHorizontalLine"></div>
          <div className="PackDetailsAllExamsFlexFullLine">
            <div className="PackDetailsAllDerivationsFlexExamLine">
              {[...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].map((exam) => (
              <div className="PackDetailsAllDerivationsSingleExamBlock" key={exam}>
                <div className="PackDetailsAllExamsSingleExamBlockUpLine">
                  <div className="PackDetailsAllExamsSingleExamBlockName">{examslist[exam].name}</div>
                </div>
                <div className="PackDetailsAllExamsSingleExamBlockDescr">{examslist[exam].description}</div>
              </div>
              ))}
            </div>
          </div>
        </div>
        </> : null}
      </div>
     </div>
      : null}

     {packslist[VisualizePack] && packslist[VisualizePack].recommended ?
      <div className="PackDetailsPacksDiv">
            <div className="PackDetailsPacksTitle">Complementa tu chequeo con alguna de estas sugerencias</div>
            <div className="PackDetailsPacksPackBoxesFullLineFlex">
              {PackPage === 1 ?
              null :
              <div className='PackDetailsPacksLeftArrowDiv' onClick={() => setPackPage(PackPage-1)}>
                <FontAwesomeIcon 
                    icon={faArrowRightLong} 
                    className='PackDetailsPacksLeftArrow text-end fa-rotate-180'
                />
              </div>
              }

              <div className="PackDetailsPacksPackBoxesFlex">
                  {packslist[VisualizePack].recommended.filter(a => packslist[a].gender === "Mixed" || packslist[a].gender === GenderCat).slice(PacksShown*(PackPage-1),PacksShown*PackPage).map((pack) => (
                  <div className="PackDetailsPacksPackBox" key={pack}>
                    <div className='PacksSelectPackBoxBackImage' style={{backgroundImage:"linear-gradient(0deg, rgba(207,249,255,1) 0%, rgba(255,255,255,0) 50%),url('https://static.yomecontrolo.cl/public/img/packs/"+ pack +".png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
                      <div className="PacksSelectPackBoxWhiteBox">
                          <div className="PackDetailsPacksPackBoxWhiteBoxTitle">{packslist[pack].name}</div>
                          <div className="PacksSelectPackBoxWhiteBoxDescription" id={pack.concat("More")}>{packslist[pack].description.split(' ').slice(0,12).join(' ')} &nbsp;
                              <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"More")}>Leer más...</span>
                          </div>
                          <div className="PacksSelectPackBoxWhiteBoxDescription PacksSelectPackBoxWhiteBoxDescriptionHidden" id={pack.concat("Less")}>{packslist[pack].description} &nbsp;
                              <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"Less")}>Leer menos...</span>
                          </div>
                          <div className="PackDetailsPacksPackBoxWhiteBoxFlex">
                              <div className="PackDetailsPacksPackBoxWhiteBoxPrice">${packslist[pack].price}</div>
                          </div>
                          <div className="PacksSelectPackBoxWhiteBoxMoreInfoButton" onClick={() => { document.body.scrollTop = 0; document.documentElement.scrollTop = 0; ChangePack(pack);}}>Más Información</div>
                      </div>
                  </div>
                  ))}
              </div>

              {PackPage === Math.ceil(packslist[VisualizePack].recommended.filter(a => packslist[a].gender === "Mixed" || packslist[a].gender === GenderCat).length / PacksShown) ?
              null :
              <div className='PackDetailsPacksRightArrowDiv' onClick={() => setPackPage(PackPage+1)}>
                <FontAwesomeIcon 
                    icon={faArrowRightLong} 
                    className='PackDetailsPacksRightArrow text-end'
                />
              </div>
              }

            </div>
        </div>
        : null}

        </div>
        <MakeItEasy/>
        <div className='ScrollBackToTopOuter ScrollBackToTopHidden' id="ToTheTop">
            <div className='ScrollBackToTop' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
            <FontAwesomeIcon 
                icon={faUpLong} 
                className='ScrollBackToTopUpArrow'
            />
            </div>
        </div>
        </div>
        </div>
        }
        </>
    );
}

export default PackDetailsRoute;